import AddAnchor from '../Presentational/CustomTransformerControl.jsx';
import AnnotationUtil from '../../../../../../Utils/AnnotationUtil';
import ThemeHelper from "ThemeHelper";
import TimeTrackingWindow from "TimeTrackingWindow";
import { Line, Group, Image } from 'react-konva';
import { RayAnnotationType, StrokeStyleType } from 'Constants/EAnnotationType';
import React, { Component } from 'react'

class TriangleControl extends Component {

    handleAnchorDragEnd = () => {
        if (this.props.activeAnchor !== '') {
            this.props.handleAnchorDragEnd();
        }
    }

    render() {
        const { id, strokeStyle, points, width, height, borderColor,
            borderWeight, bgColor, opacity, isBorderChecked, direction } = this.props.triangle;
        const isDotted = strokeStyle === StrokeStyleType.DOTTED_StrokeStyleType;
        const { isDragging, selectedAnnotId, draggable, lockImage, isApiReqResolved } = this.props;
        const { x, y, endMouseX, endMouseY } = this.props.triangle;
        let borderStroke = [];
        if (strokeStyle === 3) {
            borderStroke = [borderWeight, borderWeight];
        }
        if (strokeStyle === 2) {
            borderStroke = [borderWeight * 2.5, borderWeight];
        }
        const shapeBgColor = ThemeHelper.getThemedBrush(bgColor);
        const fillOp = AnnotationUtil.hexToRGBA(shapeBgColor, opacity);
        const shapeBorderColor = ThemeHelper.getThemedBrush(borderColor);
        TimeTrackingWindow.trackChartLoadingTime();

        return (
            <Group>
                <Line
                    id={id}
                    shape={RayAnnotationType.TRIANGLE_AnnotationType}
                    index={this.props.index}
                    x={x}
                    y={y}
                    points={[points.px1, points.py1, points.px2, points.py2, points.px3, points.py3]}
                    width={width}
                    height={height}
                    stroke={shapeBorderColor}
                    strokeWidth={isBorderChecked ? borderWeight : 0}
                    fill={fillOp}
                    dash={borderStroke}
                    direction={direction}
                    onDragStart={() => this.props.handleDragStart(this.props.triangle)}
                    onDragMove={(e) => this.props.handleDragMove(e)}
                    onDragEnd={() => isDragging && this.props.handleDragEnd()}
                    closed={true}
                    draggable={draggable && isApiReqResolved}
                    onContextMenu={(e) => draggable ? this.props.onContextMenu(e, RayAnnotationType.TRIANGLE_AnnotationType) : undefined}
                />
                {(Math.abs(points.px2) < 3 || Math.abs(points.py2) < 3) &&
                    < Line
                        id={id}
                        shape={RayAnnotationType.TRIANGLE_AnnotationType}
                        index={this.props.index}
                        x={x}
                        y={y}
                        points={[points.px1, points.py1, points.px2, points.py2, points.px3, points.py3]}
                        width={width}
                        height={height}
                        opacity={0}
                        stroke={shapeBorderColor}
                        strokeWidth={5}
                        fill={fillOp}
                        dash={borderStroke}
                        onDragStart={() => this.props.handleDragStart(this.props.triangle)}
                        onDragMove={(e) => this.props.handleDragMove(e)}
                        onDragEnd={() => isDragging && this.props.handleDragEnd()}
                        closed={true}
                        draggable={draggable && isApiReqResolved}
                        onContextMenu={(e) => draggable ? this.props.onContextMenu(e, RayAnnotationType.TRIANGLE_AnnotationType) : undefined}
                    />
                }
                {selectedAnnotId.includes(id) && !isDragging && <React.Fragment>
                    <AddAnchor x={x} y={y} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'top-left'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={x - 3} y={y - 3} />}
                    <AddAnchor x={x + width / 2} y={y} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'top-middle'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={x + width / 2 - 3} y={y - 3} />}
                    <AddAnchor x={x + width} y={y} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'top-right'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={x + width - 3} y={y - 3} />}
                    <AddAnchor x={x} y={y + height / 2} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'middle-left'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={x - 3} y={y + height / 2 - 3} />}
                    <AddAnchor x={endMouseX} y={endMouseY - height / 2} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'middle-right'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={endMouseX - 3} y={endMouseY - height / 2 - 3} />}
                    <AddAnchor x={endMouseX - width} y={endMouseY} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'bottom-left'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={endMouseX - width - 3} y={endMouseY - 3} />}
                    <AddAnchor x={endMouseX - width / 2} y={endMouseY} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'bottom-middle'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={endMouseX - width / 2 - 3} y={endMouseY - 3} />}
                    <AddAnchor x={endMouseX} y={endMouseY} annotSelected={id}
                        handleAnchorDragStart={this.props.handleAnchorDragStart}
                        handleAnchorDragMove={this.props.handleAnchorDragMove}
                        handleAnchorDragEnd={this.handleAnchorDragEnd}
                        anchorPos={'bottom-right'}
                        direction={direction}
                        type={RayAnnotationType.TRIANGLE_AnnotationType}
                        draggable={draggable}
                        onContextMenu={this.props.handleDeleteAnnotationDrawing}
                    />
                    {!draggable && <Image height={6} width={6} image={lockImage} x={endMouseX - 3} y={endMouseY - 3} />}
                </React.Fragment>}
            </Group>
        );
    }
}



export default TriangleControl;